// external libs
import { ofType } from 'redux-observable'
import { from, of } from 'rxjs'
import { switchMap, catchError } from 'rxjs/operators'

import SuriApi from '../../Services/SuriApi'

// config
import { config } from '../../Config/ConfigLoader'

// redux
import SettingsActions from '../Redux/SettingsRedux'
import FilterActions from '../Redux/FilterRedux'
import OfferActions, { OfferTypes } from '../Redux/OfferRedux'
import GeneralActions, { GeneralTypes, ERROR_TYPES } from '../Redux/GeneralRedux'

const ContentEpic = [
  (action$) =>
    action$.pipe(
      ofType(GeneralTypes.ON_GET_DEFAULT_CONTENT_REQUEST_LOADER_OFF),
      switchMap(() =>
        from(SuriApi.getDefaultContent()).pipe(
          switchMap((response) =>
            from([
              GeneralActions.onGetDefaultContentRequestSuccess(),
              GeneralActions.setInsuranceCompanies(response.data.data.insuranceCompanies),
              FilterActions.initInsuranceCompanies(
                response.data.data.insuranceCompanies,
                config.getConfig('calculatorStartsWith'),
              ),
              SettingsActions.setWebSettings(response.data.data.settings),
            ]),
          ),
          catchError((e) => of(GeneralActions.onChangeRequestFailure(e, ERROR_TYPES.CRITICAL))),
        ),
      ),
    ),
  (action$) =>
    action$.pipe(
      ofType(OfferTypes.GET_NEGOTIATION_REQUEST),
      switchMap(() =>
        from(SuriApi.getNegotiation()).pipe(
          switchMap((response) => from([OfferActions.getNegotiationRequestSuccess(response.data.data)])),
          catchError((e) => of(GeneralActions.onChangeRequestFailure(e, ERROR_TYPES.CRITICAL))),
        ),
      ),
    ),
]

export default ContentEpic
